import { Button, Chip, Tabs, Tab } from "@mui/material";
import React, { useEffect, useState, useCallback, Fragment } from "react";
import { rem, isWeb } from "assets/js/common";
import { useDispatch, useSelector } from "react-redux";
import { loadAction, loadAlert, loadFavAlert } from "redux/reducers/top";
import FloorGuide from "components/favorite-store/floor-guide";
import WayToCome from "components/favorite-store/way-to-come";
import axios from "axios";
import moment from "moment";
import AlertConfirm from "components/ui/alert-confirm";
import AlertComplete from "components/ui/alert-complete";
import { refreshFavInfo } from "assets/js/favInfo";
import { useParams, useHistory } from "react-router-dom";
import Loading from "components/ui/loading";
import { Cookies } from "react-cookie";
import { DrawerProduct } from "components/product-of-week/drawer-product";

export default function FavoriteStoreDetail(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { cd } = useParams();

  const [favoriteStoreDetail, setFavoriteStoreDetail] = useState("");
  const [open, setOpen] = useState(false);
  const [alertMode, setAlertMode] = useState("");
  const [fetching, setFetching] = useState(false);
  const [drawerHigh, setDrawerHigh] = useState(false);
  const [flyer, setFlyer] = useState([]);
  const [token, setToken] = useState("");

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const { init, alertOpen, favAlertOpen } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "매장 상세정보", menu: false }));
  }, [init]);

  useEffect(() => {
    setFetching(true);
    setToken(cookies.get("X-AUTH-TOKEN"));
    loadDetail();
    loadFlyer();
  }, []);

  const handleDrawerHighOpen = () => {
    setDrawerHigh(true);
  };
  const handleDrawerHighClose = () => {
    setDrawerHigh(false);
  };

  const [val, setVal] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setVal(newValue);
  };

  const loadFlyer = () => {
    let localToken = cookies.get("X-AUTH-TOKEN");

    axios
      .get(`/api/sm/store/get-leaflet/${localToken ? cd : "2701"}`)
      .then((res) => {
        setFlyer(res.data.data);
      })
      .catch((error) => {});
  };

  const loadDetail = () => {
    axios
      .get(`/api/sm/store/get/${cd}`)
      .then((res) => {
        setFavoriteStoreDetail(res.data.data.store);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  const registFavStore = (cd) => {
    axios.post("/api/sm/store/regist", { cd: cd }).then((res) => {
      loadDetail();
      refreshFavInfo();
    });
  };

  const handleAlertMode = (mode, item) => {
    setAlertMode(mode);
    setOpen(true);
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  const callback = () => {
    handleAlertClose(false);
    loadDetail();
  };

  const moveToPage = () => {
    if (token && !cd) dispatch(loadFavAlert(true));
    else handleDrawerHighOpen();
    // if (isWeb) {
    //   window.open(
    //     favoriteStoreDetail.ebookUrlPc,
    //     "",
    //     "width = 500, height = 800"
    //   );
    // } else {
    //   location.href = `csrmegamart://internal-url?close=N&new=Y&url=${
    //     favoriteStoreDetail.ebookUrlApp
    //   }&d=&top=1`;
    // }
  };

  window.appBackKeyHandle = () => {
    if (open) {
      setOpen(false);
    } else if (alertOpen) {
      dispatch(loadAlert(false));
    } else if (favAlertOpen) {
      dispatch(loadFavAlert(false));
    } else if (drawerHigh) {
      handleDrawerHighClose();
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <Loading open={fetching} />
      <div className="favoriteStoreDetail">
        {favoriteStoreDetail && (
          <>
            <div className="store-info">
              <div className="tit">
                {favoriteStoreDetail.nm}
                {favoriteStoreDetail.hoursOfOperInfo == "영업종료" ? (
                  <Chip
                    label="영업종료"
                    size="small"
                    className="disableChip"
                  />
                ) : favoriteStoreDetail.hoursOfOperInfo == "영업중" ? (
                  <Chip label="영업중" color="primary" size="small" />
                ) : (
                  <Chip label="휴무일" size="small" className="blackChip" />
                )}
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    favoriteStoreDetail.regularStoreYn == "Y"
                      ? handleAlertMode("alreadyFavStore")
                      : handleAlertMode("registFavStore");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/star${
                      favoriteStoreDetail.regularStoreYn == "Y"
                        ? "-on"
                        : "-off"
                    }.svg`}
                  />
                </Button>
              </div>
              <table className="info-table">
                <tbody>
                  <tr className="time">
                    <th>영업 시간</th>
                    <td>
                      {moment()
                        .hours(favoriteStoreDetail.strtTm.substring(0, 2))
                        .minutes(favoriteStoreDetail.strtTm.substring(2, 2))
                        .format("HH:mm")}
                      {" ~ "}
                      {favoriteStoreDetail.tmTp == "1" ? "" : "익일 "}
                      {moment()
                        .hours(favoriteStoreDetail.endTm.substring(0, 2))
                        .minutes(favoriteStoreDetail.endTm.substring(2, 2))
                        .format("HH:mm")}
                      {favoriteStoreDetail.tmDesc && (
                        <span className="info-txt">
                          {favoriteStoreDetail.tmDesc}
                        </span>
                      )}
                    </td>
                  </tr>
                  {favoriteStoreDetail.storeHolidayList && (
                    <tr className="calendar">
                      <th>휴무일</th>
                      <td>
                        {favoriteStoreDetail.storeHolidayList.length > 0
                          ? favoriteStoreDetail.storeHolidayList.map(
                              (holyItem, i) => (
                                <Fragment key={i}>
                                  {moment(holyItem.hldyYmd).format(
                                    "MM.DD(ddd)"
                                  )}
                                  {favoriteStoreDetail.storeHolidayList
                                    .length ==
                                  i + 1
                                    ? ""
                                    : ", "}
                                </Fragment>
                              )
                            )
                          : "연중무휴"}
                      </td>
                    </tr>
                  )}
                  <tr className="location">
                    <th>주소</th>
                    <td>{favoriteStoreDetail.addr}</td>
                  </tr>
                  {favoriteStoreDetail.tel && (
                    <tr className="call">
                      <th>대표전화</th>
                      <td>
                        <a href={`tel:${favoriteStoreDetail.tel}`}>
                          {favoriteStoreDetail.tel}
                        </a>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Button
                variant="outlined"
                fullWidth
                color="primary"
                onClick={moveToPage}
              >
                금주의 추천상품
              </Button>
            </div>
            <div className="divider" />
            <Tabs
              value={val}
              onChange={handleChangeTab}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="층별 안내" />
              <Tab label="오시는길" />
            </Tabs>
            {val == 0 ? (
              <FloorGuide
                floorList={favoriteStoreDetail.storeInformationByFloorList}
              />
            ) : (
              <WayToCome
                location={{
                  xcrdn: favoriteStoreDetail.xcrdn,
                  ycrdn: favoriteStoreDetail.ycrdn,
                  addr: favoriteStoreDetail.addr,
                  nm: favoriteStoreDetail.nm,
                }}
              />
            )}
            <div className="find-btn">
              <Button
                variant="outlined"
                color="secondary"
                className="btn-rounded end-icon"
                size="small"
                endIcon={<i className="ico-go-black" />}
                onClick={() => {
                  history.push(`/favorite-store`);
                }}
              >
                다른 매장 찾기
              </Button>
            </div>
          </>
        )}

        <DrawerProduct
          flyer={flyer}
          drawerHigh={drawerHigh}
          handleDrawerHighClose={handleDrawerHighClose}
        />
        {alertMode == "registFavStore" ? (
          <AlertConfirm
            open={open}
            handleAlertClose={handleAlertClose}
            text={`${
              favoriteStoreDetail.nm
            }을(를) 단골매장으로 설정하시겠습니까?`}
            action={() => {
              registFavStore(favoriteStoreDetail.cd);
              handleAlertClose();
            }}
            callback={callback}
          />
        ) : (
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text="다른 매장을 단골매장으로 선택해주세요."
            action={handleAlertClose}
          />
        )}
      </div>
    </>
  );
}
